import React, { useEffect, useRef } from 'react';
import { array, func, number } from 'prop-types';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

const CardDropdownList = ({ cardPharmacy, handleSubmit, submitId, setId }) => {
  const { t } = useTranslation();
  const myRef = useRef(null);
  useEffect(() => {
    document.addEventListener('keydown', handleKeydownEvent);
    return () => {
      document.removeEventListener('keydown', handleKeydownEvent);
    };
  });

  const handleKeydownEvent = e => {
    if (cardPharmacy.length > 0) {
      if (e.which === 13 && cardPharmacy.length) {
        e.preventDefault();
        const activePharmacy = _.filter(
          cardPharmacy,
          (pharmacy, index) => submitId === index
        );
        handleSubmit(activePharmacy[0]);
      }
      if (e.which === 40 && cardPharmacy.length) {
        setId(prevState =>
          prevState < cardPharmacy.length - 1 ? prevState + 1 : 0
        );
        if (cardPharmacy.length === submitId + 1) {
          setId(0);
          myRef['current'].scrollTo(0, 0);
          if (cardPharmacy.length === 1) {
            setId(0);
            myRef['current'].scrollTo(0, 0);
          }
        } else {
          const extraScroll = myRef['current'].children[0].offsetHeight;
          let scroollIntital =
            (myRef['current'].children[1].children[submitId].offsetHeight +
              10) *
              (submitId + 1) +
            extraScroll;
          myRef['current'].scrollTo(0, scroollIntital);
        }
      }
      if (e.which === 38 && cardPharmacy.length) {
        setId(prevState =>
          prevState > 0 ? prevState - 1 : cardPharmacy.length - 1
        );
        if (cardPharmacy.length === submitId + cardPharmacy.length) {
          setId(cardPharmacy.length - 1);
          let scroollIntital =
            (myRef['current'].children[1].children[submitId].offsetHeight +
              10) *
            cardPharmacy.length;
          myRef['current'].scrollTo(0, scroollIntital);
        } else {
          let scroollIntital =
            (myRef['current'].children[1].children[submitId].offsetHeight +
              10) *
              (submitId - 1) +
            22;
          myRef['current'].scrollTo(0, scroollIntital);
        }
      }
    } else if (e.which === 13) {
      e.preventDefault();
    }
  };

  return (
    <div className="cardSuggestionList">
      {cardPharmacy && cardPharmacy.length > 0 ? (
        <div className="suggestionList" ref={myRef}>
          <span className="title">{t('Pharmacies')}</span>
          <ul id="get-discount-card" role="listbox">
            {_.map(cardPharmacy, (item, id) => {
              return (
                <li
                  id={`option ${id}`}
                  className={`listItem ${id === submitId && 'active'}`}
                  key={id}
                  onMouseDown={() => handleSubmit(item)}
                  aria-label={item.name}
                  role="option"
                  aria-selected={id === submitId}
                >
                  <span>{item.name}</span>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <div className="notFountLabel">
          {t('Results not found, please try another search')}
        </div>
      )}
    </div>
  );
};

CardDropdownList.propTypes = {
  cardPharmacy: array,
  handleSubmit: func,
  setId: func,
  submitId: number
};

CardDropdownList.defaultProps = {
  cardPharmacy: [],
  handleSubmit: () => {},
  setId: () => {},
  submitId: 0
};

export default CardDropdownList;
